var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.type === "brokers"
      ? _c("div", { staticClass: "people-filters" }, [
          _c(
            "div",
            {
              staticClass: "industries",
              staticStyle: { border: "0", padding: "0" }
            },
            [
              _c("h3", [_vm._v("\n        Locations\n      ")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "options" },
                _vm._l(_vm.locations, function(location) {
                  return _c(
                    "span",
                    {
                      key: location,
                      class: _vm.locationFilter === location ? "active" : "",
                      on: {
                        click: function($event) {
                          _vm.locationFilter = location
                        }
                      }
                    },
                    [_vm._v("\n          " + _vm._s(location) + "\n        ")]
                  )
                })
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("h3", [_vm._v("\n        Industry\n      ")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "options" },
                _vm._l(_vm.industries, function(industry) {
                  return _c(
                    "span",
                    {
                      key: industry.label,
                      class:
                        _vm.industryFilter === industry.key ? "active" : "",
                      on: {
                        click: function($event) {
                          _vm.industryFilter = industry.key
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(industry.label) + "\n        "
                      )
                    ]
                  )
                })
              )
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "white-padding" }, [
      _c(
        "div",
        { staticClass: "people-list" },
        _vm._l(_vm.people, function(person) {
          return !_vm.filterOut(person)
            ? _c(
                "div",
                { key: person.name + person.title, staticClass: "person-card" },
                [
                  _c("a", { attrs: { href: person.url } }, [
                    _c("div", {
                      staticClass: "img",
                      style: _vm.photoStyle(person.photo)
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _c("h2", [
                        _vm._v(
                          "\n              " +
                            _vm._s(person.name) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("\n              " + _vm._s(person.title)),
                        _c("br"),
                        _vm._v(
                          "\n              " +
                            _vm._s(person.location) +
                            "\n            "
                        )
                      ])
                    ])
                  ])
                ]
              )
            : _vm._e()
        })
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d84a4044", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d84a4044","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/admin/people/view.vue
// module id = 557
// module chunks = 0